/* eslint-disable @typescript-eslint/no-explicit-any */
import { ServiceBus } from 'elc-service-bus';
export interface IComponentRenderer {
    init(initialMarkup?: string): void;
}

export interface IComponentRegistry {
    [key: string]: IComponent;
}
export interface ICachedComponentsRegistry {
    [key: string]: React.ComponentType<any>;
}
export interface IServiceBusKey {
    [key: string]: string;
}
export interface IServiceBusTopics {
    commands: IServiceBusKey;
    events: IServiceBusKey;
    queries: IServiceBusKey;
}
export interface IComponent {
    componentName: string;
    component: any;
    mapConfigToProps?: any;
    schema?: any;
    viewController?: any;
}

export interface IServiceRegistry {
    [key: string]: {
        name: string;
        version: string;
        isStarted: boolean;
        serviceBusController?: any;
        componentsRegistry: IComponentRegistry;
        cachedComponentsRegistry: ICachedComponentsRegistry;
        serviceInitializer: any;
        start(appConfig: any): Promise<void>;
        register?(): void;
        getView(componentName: string): IComponent;
        setViewInCache(componentName: string, component: React.ComponentType<any>): void;
        getViewFromCache(componentName: string): React.ComponentType<any>;
        registerView(
            componentName: string,
            component: any,
            mapConfigToProps?: any,
            schema?: any
        ): void;
    };
}
export interface IPayload {
    url: string;
    body?: {};
    options?: {};
    headers?: {};
}
export interface IHeaderObject {
    [key: string]: string;
}

export interface IGetPayload {
    url: string;
    options?: {};
    headers?: {};
    params?: {};
}
export interface IRequestOptions {
    debounceInterval?: number;
}
export type HeaderType = 'Business-Unit' | 'Authorization' | 'AuthorizationToken' | 'ClientId';
export type HeaderObject = { [key in HeaderType]?: string };
export interface IHttpTransport {
    setBaseUrl(baseUrl: string): void;
    addGlobalHeaders(headers: HeaderObject): void;
    removeGlobalHeader(headerName: string): void;
    delete(payload: string | IPayload): Promise<any>;
    post(payload: IPayload): Promise<any>;
    patch(payload: IPayload): Promise<any>;
    put(payload: IPayload): Promise<any>;
    get(payload: string | IGetPayload, IRequestOptions?: IRequestOptions): Promise<any>;
}

export interface IUtagData {
    [key: string]: string | string[] | undefined | boolean | number | null | number[];
}
export interface IUtagCfgOvrd {
    noview: boolean;
    dom_complete?: boolean;
    lowerqp?: boolean;
    noload?: boolean | number;
    nocookie?: boolean;
    readywait?: boolean | number;
    waittimer?: number;
}
export interface IUtag {
    link(data: IUtagData, cb?: Function): void;
    view(data: IUtagData, cb?: Function): void;
}

export interface IDrupalSite {
    translations?: any;
    trackingDataLayer?: any;
}

export interface IVersions {
    [key: string]: string;
}

declare global {
    // Augment Node.js `global`
    namespace NodeJS {
        interface Global {
            ServiceBusTopics: IServiceBusTopics;
            ServiceRegistry: IServiceRegistry;
            GlobalServiceBus: ServiceBus<any, any, any, any, any>;
            HttpTransport: IHttpTransport;
            replaceSrc(originalSrc: string): string;
            utag_data: IUtagData;
            utag_cfg_ovrd: IUtagCfgOvrd;
            utag: IUtag;
            site?: IDrupalSite;
            location: Location;
            ComponentRenderer: IComponentRenderer;
            registerTranslationFields: Function;
            registerConfigFields: Function;
            getTranslations: Function;
            versions: IVersions;
            getServiceVersions(): void;
            __ssr: boolean;
        }
    }

    // Augment Browser `window`
    interface Window {
        ServiceBusTopics: IServiceBusTopics;
        ServiceRegistry: IServiceRegistry;
        GlobalServiceBus: ServiceBus<any, any, any, any, any>;
        HttpTransport: IHttpTransport;
        replaceSrc(originalSrc: string): string;
        utag_data: any;
        utag_cfg_ovrd: IUtagCfgOvrd;
        utag: IUtag;
        location: Location;
        site?: IDrupalSite;
        addEventListener(a: string, b: Function): void;
        ComponentRenderer: IComponentRenderer;
        registerTranslationFields: Function;
        registerConfigFields: Function;
        getTranslations: Function;
        versions: IVersions;
        getServiceVersions(): void;
        __ssr: boolean;
    }

    // Augment Web Worker `self`
    interface WorkerGlobalScope {
        ServiceBusTopics: IServiceBusTopics;
        ServiceRegistry: IServiceRegistry;
        GlobalServiceBus: ServiceBus<any, any, any, any, any>;
        HttpTransport: IHttpTransport;
        replaceSrc(originalSrc: string): string;
        utag_data: IUtagData;
        utag_cfg_ovrd: IUtagCfgOvrd;
        utag: IUtag;
        location: Location;
        addEventListener(a: string, b: Function): void;
        ComponentRenderer: IComponentRenderer;
        registerTranslationFields: Function;
        registerConfigFields: Function;
    }
}

export const isWebRendered = typeof self === 'object' && self.self === self;

export const root: NodeJS.Global | Window =
    (isWebRendered && self) ||
    (typeof global === 'object' && global.global === global && global) ||
    window;
